export default {
  analytics: 'Países: {countries} | Grupos: {groups} | Operadores: {operators}',

  hints: {
    tree: {
      country: 'país',
      operator: 'operador',
      group: 'grupo',
      groupsCount: 'Grupos: {groups}',
      operatorsCount: 'Operadores: {operators}',
      mcc: 'MCC',
      mnc: 'MNC'
    }
  },

  snackbars: {
    created: 'Grupo creado',
    updated: 'Grupo actualizado',
    removed: 'Grupo eliminado'
  },

  contents: {
    confirm: {
      remove: '¿Está seguro de que desea eliminar el grupo {title}?'
    }
  },

  tabs: {
    all: 'Todos',
    checked: 'Seleccionados'
  },

  pills: {
    all: 'Disponibles',
    checked: 'Seleccionados'
  },

  errors: {
    mccmnc: {
      dictionary: 'No se encontró el diccionario para MCC/MNC.<br>Póngase en contacto con el administrador.'
    }
  }
}
